import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { PayService } from 'src/app/service/pay.service';

interface ManagedUser {
  id: number;
  firstName: string;
  lastName: string;
  phone: string;
  email?: string;
  typ: number;
}

interface ManagerNavAction {
  key: string;
  label: string;
  description: string;
  route: string;
  icon: string;
  tone: 'primary' | 'secondary' | 'light';
}

@Component({
  selector: 'app-gestionnaire',
  templateUrl: './gestionnaire.component.html',
  styleUrls: ['./gestionnaire.component.css'],
  standalone: false
})
export class GestionnaireComponent implements OnInit {
  persons: ManagedUser[] = [];
  loadingUsers = false;
  loadUsersError = '';

  readonly navigationActions: ManagerNavAction[] = [
    {
      key: 'member-create',
      label: 'Creer membre',
      description: 'Provisionner un nouveau membre et son compte principal.',
      route: '/utilisateur/admin/ajouter/membre',
      icon: 'bi bi-person-plus',
      tone: 'primary'
    },
    {
      key: 'personal-accounts',
      label: 'Comptes personnels',
      description: 'Consulter, verifier et administrer les comptes personnels.',
      route: '/utilisateur/admin/compte/personel',
      icon: 'bi bi-people',
      tone: 'secondary'
    },
    {
      key: 'business-accounts',
      label: 'Comptes pro',
      description: 'Suivre les comptes pro et les operations associees.',
      route: '/utilisateur/admin/compte/professionel',
      icon: 'bi bi-building',
      tone: 'light'
    }
  ];

  constructor(private userService: PayService, private router: Router) { }

  ngOnInit(): void {
    this.getUserliste();
  }

  getUserliste(): void {
    this.loadingUsers = true;
    this.loadUsersError = '';

    this.userService.getUtilisateurGestionnaire().pipe(take(1)).subscribe({
      next: (data: ManagedUser[]) => {
        this.persons = Array.isArray(data) ? data : [];
        this.loadingUsers = false;
      },
      error: () => {
        this.persons = [];
        this.loadingUsers = false;
        this.loadUsersError = 'Impossible de charger la liste des utilisateurs geres.';
      }
    });
  }

  openPersonalAccount(userId: number): void {
    this.router.navigateByUrl('/utilisateur/admin/compte/primaire/information/' + userId);
  }

  openBusinessAccount(userId: number): void {
    this.router.navigateByUrl('/utilisateur/admin/compte/affaire/information/' + userId);
  }

  hasBusinessAccount(user: ManagedUser): boolean {
    return Number(user?.typ) === 2;
  }

  trackUser(_: number, person: ManagedUser): number {
    return person.id;
  }

  trackAction(_: number, action: ManagerNavAction): string {
    return action.key;
  }

  get managedUsersCount(): number {
    return this.persons.length;
  }
}
